import { render, staticRenderFns } from "./UcrsAnchor.vue?vue&type=template&id=bdccd72c"
import script from "./UcrsAnchor.vue?vue&type=script&lang=js"
export * from "./UcrsAnchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports